import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=f1c25554&scoped=true&"
import script from "./TermsConditions.vue?vue&type=script&lang=js&"
export * from "./TermsConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c25554",
  null
  
)

export default component.exports